import { render, staticRenderFns } from "./iDSBottomNav.vue?vue&type=template&id=72028fc1"
import script from "./iDSBottomNav.vue?vue&type=script&lang=js"
export * from "./iDSBottomNav.vue?vue&type=script&lang=js"
import style0 from "./iDSBottomNav.vue?vue&type=style&index=0&id=72028fc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports